@if (user) {
  <div class="user-profile">
    <div class="profile-header">
      <img [src]="user.avatar_url" alt="Avatar" />
      <h2>{{ user.display_name }}</h2>
      <p>{{ user.username }}</p>
      <a href="mailto:{{ user.email }}">{{ user.email }}</a>
    </div>
    <div class="activity-info">
      <p>
        {{ "user-profile.label.created" | translate }}:
        {{ user.time_created.relative }}
      </p>
    </div>
    <div class="company-info">
      <h3>
        {{ "user-profile.label.active-company" | translate }}:
        {{ user.company_name }}
      </h3>
      <p>
        {{ "user-profile.label.default-company" | translate }}:
        {{ user.default_company.name }}
      </p>
      <p>{{ "user-profile.label.user-companies" | translate }}:</p>
      <ul>
        @for (company of user.companies; track company) {
          <li>{{ company.name }}</li>
        }
      </ul>
    </div>
    <div class="user-roles">
      <h4>{{ "user-profile.label.roles" | translate }}:</h4>
      <ul>
        @for (role of user.roles; track role) {
          <li>{{ role.title }}</li>
        }
      </ul>
    </div>
    <div class="preferences">
      <p>
        {{ "user-profile.label.timezone" | translate }}:
        {{ user.timezone.name }}
      </p>
      <p>
        {{ "user-profile.label.language" | translate }}:
        {{ user.language.name }} ({{ user.language.code }})
      </p>
      <p>
        {{ "user-profile.label.dark-mode" | translate }}:
        {{
          user.dark_mode
            ? "user-profile.message.enabled"
            : ("user-profile.message.disabled" | translate)
        }}
      </p>
    </div>
  </div>
}
